import React from "react";
import "./blog.css";
import { Link } from "react-router-dom";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

import he from "he";

const BlogDetails = () => {
  const [Blog, setBlog] = useState([]);
  const [blogcategory, setBlogcategory] = useState([]);
  const [recentblog, setRecentblog] = useState([]);
  const [comment, setComment] = useState([]);
  const [loading, setLoading] = useState(true);
  const { blogId } = useParams();
 
  const sectionRef = useRef(null);
  // BLOGS
  useEffect(() => {
    axios
      .get(`https://vedantaiasacademy.org/api/blogs.php?slugurl=${blogId}`)
      .then((response) => {
        console.log("Blog Data", response.data);
        setBlog(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
        setLoading(false);
      });
  }, []);

  // BLOG CATAGORIES
  useEffect(() => {
    axios
      .get("https://vedantaiasacademy.org/api/blog-category.php")
      .then((response1) => {
        setBlogcategory(response1.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);

  // Recent BLOG
  useEffect(() => {
    axios
      .get("https://vedantaiasacademy.org/api/otherblog.php?type=latest")
      .then((response2) => {
        setRecentblog(response2.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);

  // Comments
  // Recent BLOG
  useEffect(() => {
    axios
      .get("https://vedantaiasacademy.org/api/comments.php")
      .then((response3) => {
        setComment(response3.data);
        console.log("Comments Data", response3.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);





//   INSERT Comment
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comments: "",
    url: blogId,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://vedantaiasacademy.org/api/add_comments.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();
      console.log("API Response:", result);

      if (result.status === "success") {
        Swal.fire("Success!", result.message, "success");
        setFormData({
          name: "",
          email: "",
          comments: "",
          url: "",
        });
      } else {
        Swal.fire("Error!", result.message, "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      Swal.fire("Error!", "Network error or invalid response", "error");
    }
  };


  return (
    <div id="rs-latest-news" className="rs-latest-news ">
      {/* <img
          src="assetsfront/images/wvid.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        /> */}
      <div className="container">
        <div className="sec-title mt-4 mb-3 text-center">
          <h2>
            Blog: <span className="info-color">Details</span>
          </h2>
        </div>

        <div className="blog_container row">
          {/* Left Blog Column */}
          <div className="col-lg-8 col-md-12">
            <div className="row">
              {/* Full Width Blog Card */}

              {Blog ? (
                Blog.map((item, index) => (
                  <div className="blog_card col-12" key={index}>
                    <a
                      href={item.blog_id}
                      className="title1"
                      style={{ color: "#ff3115", fontSize: "26px" }}
                    >
                      {item.blog_title}
                    </a>
                    <div className="figure mb-3">
                      <span className="tag">📅{item.publishdate}</span>
                      <img
                        src={item.image}
                        alt="Blog"
                        style={{ height: "30%" }}
                      />
                    </div>

                    <p style={{ color: "rgb(8 0 116)" }}>
                      <div
                        className="blog-description"
                        dangerouslySetInnerHTML={{
                          __html: he.decode(item.blog_description),
                        }}
                      ></div>{" "}
                    </p>
                    <div className="blog_meta p-3">
                      <span className="text-muted">
                        <i className="fa fa-calendar" /> {item.readable_date}
                      </span>{" "}
                      &nbsp; &nbsp;
                      <span
                        className="text-muted"
                        style={{ textTransform: "capitalize" }}
                      >
                        <i className="fa fa-tags" /> {item.blog_cat_name} &nbsp;
                        &nbsp;
                        <i className="fa fa-eye" /> {item.blog_views} &nbsp;
                        &nbsp;
                        <i className="fa fa-comments" /> 0
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#002347",
                    fontSize: "30px",
                  }}
                >
                  Please wait
                  <span className="dot-loader">
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                  </span>
                </span>
              )}

              <div className="blog_card col-md-12 col-12">
                <div className="leave-comments-area">
                  <form method="post" onSubmit={handleSubmit}>
      <fieldset>
        <h4 className="title-bg" style={{ color: "#ff3115" }}>
          Leave Comments
        </h4>

        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label>Name*</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />

               
            </div>
          </div>

          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label>Email*</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="form-group mt-2">
              <label>Your comment here...</label>
              <textarea
                style={{ height: "88px" }}
                cols={10}
                rows={5}
                name="comments"
                value={formData.comments}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          </div>
        </div>

        <div className="read_more p-2">
          <button type="submit" className="btn btn-dark px-3">
            Submit
          </button>
        </div>
      </fieldset>
    </form>
                </div>
              </div>

              <div className="blog_card col-md-12 col-12">
                <div className="author-comment">
                  <h3 className="title-bg">Recent Comments</h3>
                  <ul>
                    {comment && comment.length > 0 ? (
                      comment.map((data, index3) => (
                        <li key={index3}>
                          <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                              <div className="image-comments">
                                <img
                                style={{ padding: "14%"}}
                                  src="assetsfront/images/comment.png"
                                  alt="Blog Details photo"
                                />
                              </div>
                            </div>
                            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-12 relative">
                              <span className="reply">
                                {" "}
                                <span className="date">
                                  <i
                                    className="fa fa-calendar"
                                    aria-hidden="true"
                                  />{" "}
                                  {data.readabledate}
                                </span>
                              </span>
                              <div className="dsc-comments">
                                <a href="#"> {data.name}</a>
                                <p>{data.comments}</p> <hr></hr>
                              </div>
                             
                            </div>
                          </div>
                        </li>
                      ))
                    ) : (
                      <p>Loading Comments...</p>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="col-lg-4 col-md-12 mt-4 mt-lg-0">
            {/* Search Box */}
            <div className="columns">
              <div className="box-search">
                <input
                  className="form-control"
                  placeholder="Search Here ..."
                  name="srch-term"
                  type="text"
                />
              </div>
            </div>

            {/* Recent Posts */}
            <div className="columns">
              <div className="title1">Recent Posts</div>
              <div className="posts">
                {recentblog && recentblog.length > 0 ? (
                  recentblog.map((recent, index3) => (
                    <Link to={`/blogdetails/${recent.slug}`} key={index3}>
                      <img src={recent.image} alt="" />
                      <p>{recent.blog_title}</p>
                    </Link>
                  ))
                ) : (
                  <p>Loading categories...</p>
                )}
              </div>
            </div>

            {/* Categories */}

            <div className="columns">
              <div className="title1">Categories</div>
              <div className="categories">
                {blogcategory && blogcategory.length > 0 ? (
                  blogcategory.map((cate, index2) => (
                    <a
                      key={index2}
                      href="#"
                      className="btn1"
                      style={{
                        display: "inline-block",
                        margin: 2,
                        padding: "5px 10px",
                        fontSize: 12,
                      }}
                    >
                      {cate.category_name}
                    </a>
                  ))
                ) : (
                  <p>Loading categories...</p>
                )}
              </div>
            </div>

            {/* Comments */}

            <div className="columns comments">
              <span className="title1">Recent Comments</span>

              {/* scrolling area */}
              <div
                className="marquee-box"
                onMouseOver={(e) => e.currentTarget.classList.add("paused")}
                onMouseOut={(e) => e.currentTarget.classList.remove("paused")}
              >
                <div className="marquee-track">
                    {comment && comment.length > 0 ? (
                      comment.map((data, index3) => (
                  <div className="dsc-comments">
                                <a href="#"> {data.name}</a>
                                <p>{data.comments}</p>  
                              </div>
                    ))
                    ) : (
                      <p>Loading Comments...</p>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
